import { Helmet } from 'react-helmet-async';
import EditUserResponsesView from 'src/sections/doctor-dashboard/telepackages/edit-telepackages';

export default function EditUserResponsesPage() {
  return (
    <>
      <Helmet>
        <title>Edit User Telepackage Response</title>
      </Helmet>

      <EditUserResponsesView />
    </>
  );
}
